import React from 'react';
import { useState } from 'react';
import { addTodo,deleteTodo,removeTodo } from '../actions/index';
import {useSelector, useDispatch} from 'react-redux';
import '../App.css';


const Todo = () => {
  const [inputData, setInputData] = useState("");

  const [val,setVal ] = useState("Check List");
  const dispatch = useDispatch();
  const list = useSelector((state)=>{
    return state.todoReducer.list;
  })
  const change = (event)=>{
    console.log("inputData",inputData);
    setInputData(event.target.value);
  }
  const additem = ()=>{
        if(inputData){
          dispatch(addTodo(inputData),setInputData(''))
        }else{
          alert("plz enter data");
        }
  }

 
    return (
    <>
    <div className='main-div'>
      <div className='main-child'>
        <figure>
           <figcaption>
             Add Your List Here
           </figcaption>
        </figure>
        <div className='addItems'>
          <input type='text' placeholder='Add Items....' value={inputData}
          // onChange={(event)=>{return setInputData(event.target.value)}}
          onChange={change}  
          />
          {/* <i className='fa fa-plus add-btn' onClick={()=> {if(inputData){
          dispatch(addTodo(inputData),setInputData(''))}
        }}></i> */}
          {/* <button className='fa fa-plus add-btn' onClick={()=>dispatch(addTodo(inputData),setInputData(''))}></button> */}
          <i className='fa fa-plus add-btn' onClick={additem}></i>
        </div>

        <div className='showItems'>
          {  
            list.map((elem)=>{
              console.log("element=",elem);
              return(
          <div className='eachItem' key={elem.id}>
             {/* {elem.data !== ''}  check this line again */}
            <h2>{elem.data}</h2>  
            <button className='far fa-trash-alt add-btn' title='Delete Item' onClick={()=>dispatch(deleteTodo(elem.id),setInputData(''))}></button>
              
          </div>
              )
            })
          }         
        </div>

        <div className='showItems'>
                  
            {/* {  show? */}
            <button className='btn effect04' data-sm-link-text="remove All" title='Delete All Item' onClick={()=>dispatch(removeTodo(), setInputData(''))}><span>Check List</span></button>
            {/* : */}
            {/* <button className='btn effect04' data-sm-link-text="Check List" title='Check List' onMouseOver={changeName}><span>{val}</span></button>  */}
          {/* }  */}                                      
              
        </div>

      </div>          
    </div>      
    </>
    )
}

export default Todo
